/**
 * Die Fussnote unter dem Profilbild im PDF: was an dem Bild Darstellung ist.
 * Der Leser des PDFs hat den Reiter mit seiner Legende nicht vor sich; ohne
 * den Satz saehe das Bild aus wie eine Aufnahme aus dem Gelaende.
 *
 * Nur noch dieser eine Absatz, fuer jeden Punkt gleich (Nutzer-Wunsch
 * 26.09.2026; vorher drei bis fuenf Absaetze mit Titel).
 */
export const PROFILBILD_FUSSNOTE =
	'Farben, Körnung, Steine, Bänder und Wurzeln sind Darstellungen: Körnung nach Bodenart, Steinmenge nach '
	+ 'Skelettgehalt, Bänder eines Bb-Horizonts nach den Substratzeilen im Wechsel. Der Humusgehalt dunkelt die '
	+ 'Schicht ab. Wo ein Stein, eine Wurzel oder ein Blatt liegt, ist Zufall.';
